<template>
	<div class="page">
		<div class="tabs-container">
			<v-tabs height="auto">
				<v-tab
					v-for="navItem in settingsPageList"
					:key="navItem.text"
					:to="navItem.to"
					:data-test="`settings-navbar-item-${navItem.text?.toLowerCase()}`"
				>
					<component
						:is="navItem.icon"
						class="settings-nav-icon"
					/>
					<span>{{ navItem.text }}</span>
				</v-tab>
			</v-tabs>
		</div>

		<!-- Show the child component defined in src/router/index.js for the 'Settings' route-->
		<router-view v-slot="{ Component, route }">
			<component
				:is="Component"
				:key="route.path"
			/>
		</router-view>
	</div>
</template>

<script lang="ts">
/* eslint-disable vue/multi-word-component-names */
import { defineComponent, markRaw } from "vue";
import User16 from "@carbon/icons-vue/es/user/16";
import Settings16 from "@carbon/icons-vue/es/settings/16";
import RecentlyViewed16 from "@carbon/icons-vue/es/recently-viewed/16";
import Application16 from "@carbon/icons-vue/es/application/16";
import Events16 from "@carbon/icons-vue/es/events/16";

type SettingsNavItem = {
	text: string;
	to: {
		name: string;
	};
	icon: object;
};

type ComponentData = {
	settingsPageList: SettingsNavItem[];
};

export default defineComponent({
	name: "Settings",
	data: (): ComponentData => ({
		settingsPageList: [
			{ text: "My Account", to: { name: "Settings_profile" }, icon: markRaw(User16) },
			{ text: "General", to: { name: "Settings_general" }, icon: markRaw(Settings16) },
			{ text: "Account Logs", to: { name: "Settings_accountLogs" }, icon: markRaw(RecentlyViewed16) },
			{ text: "Compute Engine API", to: { name: "Settings_cloudEngineAPI" }, icon: markRaw(Application16) },
			{ text: "Organizations", to: { name: "Settings_organizations" }, icon: markRaw(Events16) },
		],
	}),
});
</script>

<style lang="scss" scoped>
.settings-nav-icon {
	display: inline-block;
	width: 16px;
	height: 16px;
	color: currentColor;
}
</style>
